import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({
  items,
  tone = "dark",
}: {
  items: Crumb[];
  tone?: "dark" | "light";
}) {
  const base = tone === "light" ? "text-primary-200" : "text-foreground-500";
  const linkHover = tone === "light" ? "hover:text-background-50" : "hover:text-primary-700";
  const current = tone === "light" ? "text-background-50" : "text-foreground-800";
  const sep = tone === "light" ? "text-primary-400" : "text-background-400";

  return (
    <nav aria-label="面包屑" className={`flex flex-wrap items-center gap-2 text-xs ${base}`}>
      <Link to="/" className={`flex items-center gap-1 cursor-pointer ${linkHover}`}>
        <span className="flex h-3.5 w-3.5 items-center justify-center">
          <i className="ri-home-4-line"></i>
        </span>
        首页
      </Link>
      {items.map((item, i) => (
        <span key={`${item.label}-${i}`} className="flex items-center gap-2">
          <span className={`flex h-3.5 w-3.5 items-center justify-center ${sep}`}>
            <i className="ri-arrow-right-s-line"></i>
          </span>
          {item.to ? (
            <Link to={item.to} className={`cursor-pointer ${linkHover}`}>
              {item.label}
            </Link>
          ) : (
            <span className={current}>{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}